import { OVEntity, OVField } from '@ov-suite/ov-metadata';
import { FormModel } from './form.model';

@OVEntity('MobileUserConfigList', 'shared')
export class MobileUserConfigLabelModel {
  @OVField({ type: 'string' })
  id: number;

  @OVField({ type: 'string' })
  label: string;

  @OVField({ type: 'string' })
  value: string;
}

@OVEntity('MobileUserConfig')
export class MobileUserConfigModel {
  @OVField({ type: 'number' })
  id: number;

  @OVField({ type: 'string' })
  name: string;

  @OVField({ type: 'string' })
  type: string;

  @OVField({ type: 'string' })
  category: string;

  @OVField({ type: 'string' })
  icon: string;

  @OVField({ type: 'string' })
  processDefinitionKey: string;

  @OVField({ type: 'boolean' })
  scanToStart: boolean;

  @OVField({ type: 'boolean' })
  scanToClaim: boolean;

  @OVField({ type: 'boolean' })
  tapToStart: boolean;

  @OVField({ type: 'boolean' })
  tapToContinue: boolean;

  @OVField({ type: 'boolean' })
  scanToContinue: boolean;

  @OVField({ type: () => FormModel })
  emptyReadyForm: FormModel;

  @OVField({ type: () => FormModel })
  emptyActiveForm: FormModel;

  @OVField({ type: 'string' })
  readyTabLabel: string;

  @OVField({ type: 'string' })
  activeTabLabel: string;

  @OVField({ type: () => [MobileUserConfigLabelModel] })
  labels: MobileUserConfigLabelModel[];
}
